// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"96e3d90e","455":"4b5638d2"}[chunkId] + ".chunk.js";
};